import { useTicketTemplatesQuery } from "@ticketingplatform/api/dist/ticketTemplate";
import { TicketTemplatesVariables } from "@ticketingplatform/api/dist/ticketTemplate/__generated__/TicketTemplates";
import {
  QueryMode,
  SortDirection,
} from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { useVenueContext } from "contexts/VenueContext";
import { useAutoComplete } from "hooks/useAutoComplete";
import { useDebouncedValue } from "hooks/useDebouncedValue";
import { useState } from "react";

import { UseTicketTemplateSelect } from "./types";

export const useTicketTemplateSelect: UseTicketTemplateSelect = (props) => {
  const { venue } = useVenueContext();
  const [open, onDropdownVisibleChange] = useState(false);
  const [searchValue, debouncedSearch, onSearch] = useDebouncedValue<
    string | undefined
  >(undefined, 1000);

  const baseFilters: TicketTemplatesVariables["filters"] = {
    ticketPools: {
      some: {},
    },
    ...(venue && { venueId: { equals: venue.id } }),
  };
  const { data, loading } = useTicketTemplatesQuery({
    skip: !open,
    variables: {
      skipTicketPools: true,
      orderBy: [{ name: SortDirection.asc }],
      take: 10,
      filters: debouncedSearch
        ? {
            name: {
              contains: debouncedSearch,
              mode: QueryMode.insensitive,
            },
            ...baseFilters,
          }
        : baseFilters,
    },
  });

  return useAutoComplete({
    ...props,
    loading,
    open,
    searchValue,
    onDropdownVisibleChange,
    onSearch,
    options: data?.ticketTemplates?.nodes || [],
    valueProp: "id",
    labelProp: "name",
  });
};
